import base from "/Users/mehakpreetsingh/Documents/NextJs App/monochrome/images/facebook.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");